var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cube-of-knowledge p-15 br-10 g-9 row-center align-center",class:_vm.color},[_c('h2',{staticClass:"text-h3"},[_vm._v(_vm._s(_vm.cubeText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }